import styled from 'styled-components';

export default styled.div`
  display: block !important;

  .mainScore {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;
  }

  .ordinaryScore {
    text-align: center;
    font-size: 12px;
  }

  .score {
    font-size: 36px;
    margin: 0 20px;
    letter-spacing: 4px;
    font-weight: bold;
    text-align: center;
  }
`;
